import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { GlobalConstants } from 'src/app/common/constants/global.constant';
import { DevicesConstants } from 'src/app/core/routing/services/devices/constants/devices.constants';
import { DeviceStoreService } from '../store/device.store';
import { CustomMainTileContent } from '../interface/devices-interface.i';
import { GoogleAnalyticsService } from '../../google-analytics/google-analytics.service';

@Component({
  selector: 'iposcen-device-custom-main-tile',
  templateUrl: './device-custom-main-tile.component.html',
  styleUrls: ['./device-custom-main-tile.component.scss']
})
export class DeviceCustomMainTileComponent implements OnInit {
  isDeviceMainTileAssetNone: boolean;
  // isSelectedData = new Map();
  isCustomMainTileEmpty: boolean;
  CustomMainTileLength = 0;
  customHeroTiles: CustomMainTileContent[] = [];
  cancelChanges = GlobalConstants.CANCEL;
  successMessage: string;
  description: string;
  isCancel:boolean = false;
  openModalPopup = false;
  deviceConst = DevicesConstants;
  saveChanges = GlobalConstants.SAVE_CHANGES;
  buttonLabelNo = DevicesConstants.NO;
  buttonLabelCancel = DevicesConstants.CANCEL_UPDATE;
  isDeviceCustomMainNone: boolean;
  noneSelected: boolean;
  noneChecked = false;
  checkIfEnabeled = new Map();
  CustomData = new Map();
  isSelectedData = new Map();
  selctedContGrpsForProfile: any = {
    selectedCG: []
  };
  customSelectedPayload = {
    customHeroTiles :[]
  };
  page = 1;
  pageSize = 5;
  maxSize = 5;
  @Output() readonly dismissFunc = new EventEmitter();
  @Output() readonly lastUpdateTime = new EventEmitter();
  idselected: string;
  

  constructor( private deviceStore: DeviceStoreService,
     private googleAnalyticsService: GoogleAnalyticsService) { }

  ngOnInit(): void {
    this.googleAnalyticsService.devieInfoTabName('Main_Tile');
    const storeData = this.deviceStore.deviceStoreData;
    if(storeData?.customHeroTiles){
    if(storeData?.customHeroTiles.length == 0){
      this.noneChecked = true;
      this.noneSelected = true;
    } else {
      this.noneChecked = false;
      this.noneSelected = false;
    }
    this.idselected = !(storeData?.customHeroTiles.length) ? undefined : storeData?.customHeroTiles[0].customHeroTileId;
  }
  }

  getCustomMainTileLength(event) {
    this.isCustomMainTileEmpty = (event > 0) ? false : true;
    this.CustomMainTileLength = event;
  }

  getCustomMainData(data) {
    if (data === 'None') {
      this.customSelectedPayload = {
        customHeroTiles :[]
      };
      this.idselected = undefined;
      this.noneSelected = true;
    } else {
      this.customSelectedPayload = {
        customHeroTiles: [{
          customHeroTileId: data.customHeroTileId,
          showOnDevice: true
        }]
      };
      this.idselected = data.customHeroTileId;
      this.noneSelected = false;
  }
}


  cancel() {
    this.successMessage = DevicesConstants.DEVICE_CANCEL_TITLE;
    this.description = DevicesConstants.DEVICE_CANCEL_DESC;
    this.isCancel = true;
    this.openModalPopup = !this.openModalPopup;
  }

  closeModal() {
    this.openModalPopup = !this.openModalPopup;
  }

  sendDataToStore() {
    this.openModalPopup = !this.openModalPopup;
    this.successMessage = DevicesConstants.DEVICE_UPDATE_SAVED;
    this.description = DevicesConstants.DEVICE_UPDATE_DESC;
    this.customHeroTiles = [];

    if (this.noneSelected) {
      this.deviceStore.updateDeviceData({customHeroTiles: []})
    } else {
      this.deviceStore.updateDeviceData(this.customSelectedPayload);
    }
    this.deviceStore.updateDeviceData(this.customSelectedPayload);
    this.isCancel = false;
    this.lastUpdateTime.emit(true);
    this.googleAnalyticsService.devieInfoChangesSaved('Main_Tile');
  }

  dismiss() {
    this.dismissFunc.emit('');
    this.openModalPopup = !this.openModalPopup;
    this.isCancel = false;
  }

  removeCustomMainDevice(){
    this.noneSelected = true;
  }

}
